export default String.raw`
<dialog class="newsletterPopup dialog popup-timer-js">
    <div class="newsletterPopup__body">
        <div class="newsletterPopup__header">
            <h2>Nie przegap okazji</h2>
            <form method="dialog">
                <button class="close-js" aria-label="{{translations.Close}}">
                    <svg aria-hidden="true">
                        <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{ settings.iconStyle }}'></use>
                    </svg>
                </button>
            </form>
        </div>
        <div class="newsletterPopup__content">
            <div class="newsletterPopup__content-left">
                <div>
                    <svg>
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#newspaper-{{ settings.iconStyle }}"></use>
                    </svg>
                    <span>
                        {{ translations.NewMagazines }}
                    </span>
                </div>
                <div>
                    <svg>
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#percent-{{ settings.iconStyle }}"></use>
                    </svg>
                    <span>
                        {{ translations.UniqueOffers }}
                    </span>
                </div>
                <div>
                    <svg>
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#truck-{{ settings.iconStyle }}"></use>
                    </svg>
                    <span>
                        {{ translations.DeliverySchedule }}
                    </span>
                </div>
                <div>
                    <svg>
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lightbulb-on-{{ settings.iconStyle }}"></use>
                    </svg>
                    <span>
                        {{ translations.InspirationsAndTips }}
                    </span>
                </div>
            </div>
            <form class="newsletterPopup__content-right newsletter-form-js">
                <p>{{ translations.JoinNewsletter2 }}</p>
                <div class="newsletterPopup__content-right-email">
                    <svg>
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{ settings.iconStyle }}"></use>
                    </svg>
                    <input name="email" aria-label="input-email" type="email" placeholder="{{translations.NewsletterInputPlaceholder}}" autocomplete="email" maxlength="192" required>
                </div>
                <div class="checkBoxes__container newsletterPopup__content-right-buttons">
                    {% for tos in config.TOS.Consents.Newsletter -%}
                        {% if tos.Statement == false -%}
                            <input aria-label="tos" id="{{ tos.Id }}pop" type="checkbox" name="tos" value="{{ tos.Id }}" {% if tos.Required -%} required {% endif -%} >
                            <label for="{{ tos.Id }}pop" tabindex="0" role="checkbox" aria-checked="false">
                                <span class="checkBoxes__checkIcon">
                                    <svg>
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
                                    </svg>
                                </span>
                                <span>
                                    {% if tos.Required -%}<span style="color: #9E0000;">* </span>{% endif -%}{{ tos.Text }}
                                </span>
                            </label>
                            {% for channel in tos.Channels -%}
                                <input id="{{ channel.Id }}" type="hidden" name="channel" value="{{ channel.Key }}" >
                            {% endfor -%}
                        {% else -%}
                        <p>
                            {% for channel in tos.Channels -%}
                                <input id="{{ channel.Id }}" type="hidden" name="channel" value="{{ channel.Key }}" >
                            {% endfor -%}
                            <input aria-label="tos" id="{{ tos.Id }}pop" type="hidden" name="tos" value="{{ tos.Id }}" checked>
                            {{ tos.Text }}
                        </p>
                        {% endif -%}
                    {% endfor -%}
                    <button class="primary-action-button">
                        {{ translations.SaveMe }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</dialog>
`